import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { issueCouponFetchApi } from '../../../../app/Helper/CouponHelper';

/**
 * 파트너 쿠폰 바로 받기 버튼
 */
function PartnerBurdenButton({
  couponSrl,
  issuedButton,
  issueCouponData,
  groupSeqNo,
  setIsToast,
}) {
  const partnerBurdenButtonRef = useRef(null);
  const toastTimeoutRef = useRef(null);
  useEffect(() => {
    if (!issueCouponData.resultMsg) return;
    
    setIsToast(true);
    clearTimeout(toastTimeoutRef.current);
    toastTimeoutRef.current = setTimeout(() => {
      setIsToast(false);
    }, 2200);
  }, [issueCouponData, setIsToast]);

  const onClick = useCallback(
    e => {
      e.preventDefault();
      TMON.sendLog(null, [
        partnerBurdenButtonRef.current,
        null,
        {
          'tl:area': 'DDCP',
          'tl:dimension': `main_deal_srl:${TMON.htStaticData.htDealInfo.dealNo}`,
        },
      ]);

      if (issuedButton) return;
      if (!TMON.bLogin) {
        TMON.oApp.oUtil.login();
        return;
      }

      issueCouponFetchApi(
        groupSeqNo > 0
          ? { type: 'groupNo', couponSrl: groupSeqNo }
          : { type: 'couponNo', couponSrl }
      );
    },
    [couponSrl, groupSeqNo, issuedButton]
  );

  return (
    <>
      <button
        type="button"
        className={`partner_burden_coupon${issuedButton ? ' off' : ''}`}
        onClick={onClick}
        ref={partnerBurdenButtonRef}
      >
        <span className="blind">쿠폰 바로받기</span>
      </button>
    </>
  );
}

PartnerBurdenButton.propTypes = {
  couponSrl: PropTypes.number,
  issuedButton: PropTypes.bool,
  issueCouponData: PropTypes.shape({}),
  setIsToast: PropTypes.func,
};

export default PartnerBurdenButton;
